jQuery(function ($) {
  const section = $('[data-singleDoc]');
  const tree = section.find('.vldocs-navigation');
  const treeToggle = section.find('.singleDoc-aside h2');
  const searchToggle = section.find('[data-search-toggle]');
  const searchInput = $('#vldocs-search-text');
  const body = $('body');

  // version switcher
  section.find('.vldocs-version-switch').on('change', function () {
    window.location.href = $(this).val();
  });

  // document tree
  tree.find('.sub-menu').parent().addClass('has-toggle').prepend('<button class="is-toggle"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17"><path d="M5.425 3.512a.942.942 0 01.729-.31c.28 0 .517.104.712.31l4.368 4.598c.195.206.296.46.302.76 0 .293-.101.546-.302.758l-4.36 4.59a.955.955 0 01-.72.318.987.987 0 01-.721-.318 1.066 1.066 0 01-.302-.76c0-.293.1-.546.302-.758l2.615-2.754.884-1.077-.884-1.077L5.425 5.03a1.048 1.048 0 01-.294-.75c-.005-.3.092-.557.294-.768z" fill="#007C8A" fill-rule="evenodd"/></svg></button>');

  // open grandchildren of current item
  $.each(tree.find('.current-menu-item').parents('li'), function () {
    $(this).children('button').addClass('is-open');
  });

  // toggle functionality
  tree.find('button').on('click', function () {
    $(this).toggleClass('is-open');
  });

  // open direct children of current item
  tree.find('.current-menu-item > button.is-toggle').trigger('click');

  // treat links with a submenu as button toggles
  // tree.find('a').on('click', function (e) {
  //   const button = $(this).prev('button.is-toggle');

  //   if (button.length) {
  //     e.preventDefault();
  //     button.trigger('click');
  //   }
  // });

  // mobile collapse
  treeToggle.append('<svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29"><path d="M23.605 8.493c.37.352.55.777.54 1.276 0 .49-.18.905-.54 1.247l-8.047 7.643a1.91 1.91 0 01-1.33.528c-.514 0-.956-.176-1.327-.528l-8.032-7.628c-.37-.352-.556-.773-.556-1.262.01-.499.196-.92.556-1.26.37-.353.814-.529 1.328-.529.515 0 .958.176 1.329.528l4.82 4.576 1.883 1.546 1.885-1.546 4.835-4.59c.36-.342.798-.513 1.312-.513.526-.01.974.16 1.344.513z" fill="#007C8A" fill-rule="evenodd"/></svg>');

  treeToggle.on('click', function () {
    section.find('.singleDoc-aside').toggleClass('is-open');
  });

  // lightbox
  section.find('a[href$=".png"], a[href$=".jpg"]').addClass('is-lightbox');

  const prvs = new Parvus({
    selector: '.is-lightbox',
    gallerySelector: '[data-singleDoc]'
  });

  // sticky sidebar
  section.find('[data-sticky]').stickySidebar({
    topSpacing: function () {
      const adminbar = $('#wpadminbar');

      if (adminbar.length) {
        return $('[data-header]').height() + adminbar.height() + 32;
      } else {
        return $('[data-header]').height() + 32;
      }
    },
    bottomSpacing: 32,
    innerWrapperSelector : '.singleDoc-navigation-inner'
  });

  // search toggle
  $(document)
    .on('keyup', function(e) {
      if (e.keyCode === 27) { // close on esc
        body.removeClass('is-search');
      }

      if (e.keyCode === 111 || e.keyCode === 55) { // toggle search on / (shift + 7) and numpad-/
        body.toggleClass('is-search');

        if (body.hasClass('is-search')) {
          searchInput.focus();
        }
      }
    })
    .on('click', function (e) {
      // close on click outside of searchbox
      if ($('[data-search]').find(e.target).length === 0 && !searchToggle.is(e.target)) {
        body.removeClass('is-search');
      }
    });

  searchToggle.on('click', function (e) {
    body.addClass('is-search');
    searchInput.focus();
  });
});
